import React from 'react';
import Emoji from './Emoji';
import ReactionAvatarStack from './ReactionAvatarStack';
import showFullPageSheet from './showFullPageSheet';
import { gql } from '../../graphql/generated/gql';
import type { ExtractReactionThreadTypes } from '../../utils/post/threadUtils';
import { usePostLayoutSize } from '../../utils/responsive/PostLayoutSizeProvider';

const THREAD_FRAGMENT = gql(`
  fragment ReactionThreadCompact_thread on RootThreadFields {
    id
    ... on ReactionThread {
      reactions {
        id
        ...ReactionAvatarStack_reaction
      }
    }
    ... on PublicReactionThread {
      reactions {
        id
        ...ReactionAvatarStack_reaction
      }
    }
  }
`);

interface ReactionThreadCompactProps {
  thread: ExtractReactionThreadTypes<typeof THREAD_FRAGMENT>;
  focused: boolean;
}

const ReactionThreadCompact = ({
  thread,
  focused,
}: ReactionThreadCompactProps) => {
  const postLayoutSize = usePostLayoutSize();
  const canOnlyShowOne = postLayoutSize === 'mobile';

  const hasRing = focused && showFullPageSheet();

  if (postLayoutSize === 'tablet') {
    const firstEmoji = thread.reactions.at(0)?.emoji;
    return firstEmoji ? <Emoji char={firstEmoji} size="medium" /> : null;
  }

  return (
    <ReactionAvatarStack
      maxItemsShown={3}
      reactions={
        canOnlyShowOne ? thread.reactions.slice(0, 1) : thread.reactions
      }
      ring={hasRing}
    />
  );
};

export default ReactionThreadCompact;
